import React from 'react';
import PropTypes from 'prop-types';
import CustomModal from './Modal';
import { useI18n } from 'utils/I18n/context';

export default function BannerPreview({ isVisible, url, width, height, title, onClose }) {
    const { t } = useI18n();
    if (!url) return null;

    const staticNames = t?.offersPage?.offer || {};

    return (
        <CustomModal
            visible={isVisible}
            onClose={onClose}
            title={staticNames.preview || title}
            areNoControls
            className="modal-responsive modal-banner"
        >
            <div className="banner-preview">
                <div className="banner-preview__wrapp">
                    <div className="banner-preview__axis banner-preview__axis_y">
                        <div className="banner-preview__size">{height}px</div>
                    </div>
                    <div className="banner-preview__axis banner-preview__axis_x">
                        <div className="banner-preview__size">{width}px</div>
                    </div>
                    <img className="banner-preview__image" src={url} alt={title || staticNames.preview} />
                </div>
            </div>
        </CustomModal>
    );
}

BannerPreview.propTypes = {
    isVisible: PropTypes.bool,
    url: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    onClose: PropTypes.func,
};
